import { Alert, AlertDescription } from '@awpmarine/ui/components/ui/alert';
import { ParaglideMessage } from '@inlang/paraglide-js-react';
import { InfoIcon } from 'lucide-react';

import { useLanguageLinks } from '@/components/language';
import { baseLanguageTag } from '@/lib/locale';
import { m } from '@/paraglide/messages';
import { baseLocale, getLocale } from '@/paraglide/runtime';

/** The `lang` for content shown in another locale's pages before it is translated. */
export function contentLang(translated: boolean) {
  return translated ? undefined : baseLanguageTag;
}

/** Tells a reader the content is in English, or that it is a translation of an English original. Nothing on English pages. */
export function ContentLanguageNotice({
  translated,
  binding = false,
}: {
  translated: boolean;
  /** A legal text, where the English original is the one that applies. */
  binding?: boolean;
}) {
  // The same link the language menu offers, so the two always agree on where the English page is.
  const english = useLanguageLinks().find((link) => link.locale === baseLocale)!;
  if (getLocale() === baseLocale || (translated && !binding)) return null;

  return (
    <Alert className='mt-6 rounded-xl border-0 bg-[#eef3fa] px-4 py-3 text-[#1f4a80]'>
      <InfoIcon />
      <AlertDescription className='text-base text-[#1f4a80]'>
        {translated ? (
          <ParaglideMessage
            message={m.legal_translation_notice}
            inputs={{}}
            markup={{
              link: ({ children }) => (
                <a href={english.href} {...english.props} className='underline underline-offset-4 hover:text-brand'>
                  {children}
                </a>
              ),
            }}
          />
        ) : (
          m.content_english_only()
        )}
      </AlertDescription>
    </Alert>
  );
}
